import React, { useState, useEffect, useRef, useContext } from 'react';
import { Text, View } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import { Camera as ExpoCamera } from 'expo-camera';
import { Container, Header, Title, IconFE, ContentButtonCamera, ButtonTakePhoto, IconFA5, ButtonNewPhoto, TextButtonNewPhoto, Photo, ButtonSend, TextButtonSend, Camera } from './styles';
import RouteContext from '../../../context/route';

const ConfirmDelivery = () => {
    const camRef = useRef(null);
    const navigation = useNavigation();
    const [hasPermission, setHasPermission] = useState(null);
    const { setFinalizeDelivery } = useContext(RouteContext);
    const [photo, setPhoto] = useState(null);

    useEffect(() => {
        (async () => {
        const { status } = await ExpoCamera.requestCameraPermissionsAsync();
        setHasPermission(status === 'granted');
        })();
    }, []);

    if (hasPermission === null) {
        return <View />;
    }
    if (hasPermission === false) {
        return <Text>No access to camera</Text>;
    }

    async function takePhoto(){
        if(camRef){
            const data = await camRef.current.takePictureAsync({base64: true});
            setPhoto(data.base64);
        }
    }

    // No nativo, takePictureAsync devolve base64 puro. No Web, expo-camera usa
    // canvas.toDataURL() por baixo dos panos e já devolve a data URI completa
    // (data:image/png;base64,...). Sem essa checagem, a URI da preview ficava
    // com o prefixo duplicado e o backend recebia um base64 inválido.
    function toDataUri(base64: string) {
        return base64.startsWith('data:') ? base64 : `data:image/jpg;base64,${base64}`;
    }

    function toRawBase64(base64: string) {
        return base64.startsWith('data:') ? base64.split(',')[1] : base64;
    }

    function sendPhoto() {
        setFinalizeDelivery((prevState: any) => ({
            ...prevState,
            image: toRawBase64(photo)
        }));
        backPage();
    }

    function backPage(){
        navigation.goBack();
    }

    return(
        <Container>
            <Header>
                <IconFE 
                    name="arrow-left" 
                    size={25} 
                    color="#fff"
                    onPress={backPage}
                />
                <Title>Confirmar entrega</Title>
                <View/>
            </Header>

            <View style={{ paddingHorizontal: 24, flex: 1, borderRadius: 5 }}>
                {!photo &&
                    <Camera 
                        ref={camRef}
                    >
                        <ContentButtonCamera>
                            <ButtonTakePhoto  onPress={takePhoto}>
                                <IconFA5 name="camera" size={30} color="#fff" />
                            </ButtonTakePhoto>
                        </ContentButtonCamera>
                    </Camera>
                }

                {photo &&
                    <>
                        <View>
                            <ButtonNewPhoto onPress={() => setPhoto(null)}>
                                <TextButtonNewPhoto>Tirar foto novamente</TextButtonNewPhoto>
                            </ButtonNewPhoto>
                            <Photo source={{ uri: toDataUri(photo) }}/>
                        </View>
                        <ButtonSend onPress={sendPhoto}>
                            <TextButtonSend>Enviar</TextButtonSend>
                        </ButtonSend>
                    </>
                }
            </View>
        </Container>
    );
};

export default ConfirmDelivery;